<template>
  <div id="play-back-player">
    <component
      :is="componentType === 'div' ? 'div' : 'vs-popup'"
      class="popup-play-back-player"
      :title="title"
      :active.sync="popupActive"
    >
      <div id="play-back-player-container">
        <!-- カメラ読み込み中 -->
        <div v-show="isLoadingCamera" class="history-camera-no-video">
          <video class="no-video"></video>
          <p>{{ cameraMsg }}</p>
        </div>
        <!-- カメラ -->
        <div id="video-container" @fullscreenchange="onFullscreenChange">
          <div id="item-main-video" v-show="!isLoadingCamera">
            <video
              :id="video.id"
              class="video"
              v-show="active_video === video.start"
              v-for="video in playVideoPathList"
              :key="video.start"
              @loadeddata="onloadeddata"
              :ref="video.start"
            >
              <source :src="video.path" type="video/mp4" />
            </video>
          </div>
          <div id="item-video-controls">
            <play-back-controls
              :current="current"
              :start="playStart"
              :end="playEnd"
              ref="playBackControls"
              @onPlay="onPlay"
              @onChangeVolume="onChangeVolume"
              @setFPS="setFPS"
              @onChangeSeek="onChangeSeek"
              @onChangeFullscreen="setFullscreen"
            ></play-back-controls>
          </div>
        </div>
        <div id="item-playlist">
          <div id="playlist-container">
            <div id="area-playlist-header">
              <p>再生リスト</p>
              <vs-divider />
            </div>
            <div id="area-playlist-content">
              <component
                class="scroll-area"
                :is="scrollbarTag"
                :settings="settings"
                :key="$vs.rtl"
              >
                <ul class="camera-play-list">
                  <li
                    class="flex items-center play-list-item"
                    v-for="item in playList"
                    :key="item.video.id"
                    @click="onClickPlaylist(item.video.id)"
                  >
                    <div class="mr-4">
                      <div class="flex">
                        <video width="80" height="60">
                          <source :src="item.video.path" />
                        </video>
                      </div>
                    </div>
                    <div class="play-list-item-info">
                      <p class="font-medium truncate">{{ item.duration }}</p>
                      <p
                        v-if="item.video.id == currentPlaylistId"
                        class="text-xs on-playing"
                      >
                        再生中
                      </p>
                    </div>
                  </li>
                </ul>
              </component>
            </div>
          </div>
        </div>
      </div>
    </component>
  </div>
</template>

<script>
import moment from "moment-timezone";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { storageWebCam } from "@/firebase/firebaseConfig";
import _ from "lodash";
import * as createjs from "@createjs/core";

import fullscreen from "vue-fullscreen";
import Vue from "vue";
Vue.use(fullscreen);

export default {
  components: {
    VuePerfectScrollbar,
    PlayBackControls: () => import("./PlayBackControls"),
  },
  props: {
    camera: { type: Object, required: true },
    componentType: { type: String, required: false },
  },
  data() {
    return {
      initialized: false,
      video: null,
      active_video: null,
      popupActive: false,
      current: 0,
      start: 0,
      end: 0,
      playStart: 0,
      playEnd: 0,
      playCurrent: 0,
      cameraHash: "",
      settings: {
        suppressScrollX: true,
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      videoList: [],
      playVideoPathList: [],
      load_count: 0,
      video_time: 0,
      timeCount: 0,
      is_ready: false,
      playList: [],
      ticker: null,
      tickerListener: null,
      fps: 1,
      isPlay: false,
      isEnded: false,
      volume: 0,
      isLoadingCamera: true,
      cameraMsg: "",
      currentPlaylistId: null,
      isSeekEvent: false,
    };
  },
  computed: {
    scrollbarTag() {
      return this.$store.state.is_touch_device ? "div" : "VuePerfectScrollbar";
    },
    title() {
      let startLocal = moment
        .unix(this.start)
        .tz("Asia/Tokyo")
        .format("YYYY年MM月DD日 HH:mm");
      let endLocal = moment.unix(this.end).tz("Asia/Tokyo").format("HH:mm");
      let cameraTitle = this.camera.name;
      return `${cameraTitle}  ${startLocal} - ${endLocal}`;
    },
  },
  watch: {
    current() {
      if (this.current === this.playEnd) {
        this.isEnded = true;
        this.onPause();
      } else {
        this.setVideoResource();
      }
    },
  },
  methods: {
    async show(payload) {
      // Dev環境テスト用
      // this.start = moment("2020-09-10T14:00:00.000Z").unix();
      // this.end = moment("2020-09-10T15:00:00.000Z").unix();
      // this.cameraHash =
      //   "a5866283f7207b6e7824f59fba132833941d7c3e1f81339ae2c198f722636fed";

      this.start = moment(payload.utcStartTime).unix();
      this.end = moment(payload.utcEndTime).unix();
      this.cameraHash = this.camera.hash;
      this.is_ready = false;
      this.videoList = [];
      this.load_count = 0;
      this.fps = 1;
      this.$refs.playBackControls.init();
      await this.getVideoPath();
      if (this.videoList.length !== 0) {
        this.popupActive = true;
        await this.cratePlayVideoPathList(this.videoList[0].id);
        this.cratePlayList();
      } else {
        this.openNoVideoAlert();
      }
    },

    openNoVideoAlert() {
      let startLocal = moment
        .unix(this.start)
        .tz("Asia/Tokyo")
        .format("YYYY年MM月DD日 HH:mm");
      let endLocal = moment.unix(this.end).tz("Asia/Tokyo").format("HH:mm");
      this.$vs.dialog({
        color: "danger",
        title: `カメラ映像が見つかりませんでした`,
        text: `${startLocal}~${endLocal}のカメラ映像が見つかりませんでした。他の時間帯を選択してください。`,
        acceptText: "OK",
        accept: this.closeNoVideoAlert,
      });
    },

    closeNoVideoAlert() {
      this.$emit("reOpenDialog");
    },

    setVideoResource() {
      if (!this.initialized) return;
      let v = this.getCurrentVideo(this.current);
      if (v) {
        if (v.start != this.active_video) {
          this.active_video = v.start;
          this.video_time = v.start;
        }
        let videoTag = this.$refs[v.start][0];
        if (videoTag) {
          let diff = this.current - v.start;
          if (this.video_time + 1 < this.current) {
            videoTag.pause();
            this.video_time += diff;
            videoTag.currentTime += diff;
          } else {
            if (this.fps <= 2) {
              videoTag.playbackRate = this.fps;
              videoTag.volume = this.volume;
              if (this.isPlay) {
                videoTag.play();
              } else {
                videoTag.pause();
              }
              this.video_time += this.fps;
            } else {
              videoTag.pause();
              this.video_time++;
              videoTag.currentTime++;
            }
          }
        }
      }
    },

    async getVideoPath() {
      const startMoment = moment.unix(this.start).utc();
      const endMoment = moment.unix(this.end).utc();
      const max = endMoment.diff(startMoment, "hours", true);

      // ファイル一覧取得の YYYYMMDD/HH は少し広めに取得。
      let dateList = [];
      for (let i = -1; i < Math.ceil(max) + 1; i++) {
        dateList.push(startMoment.add(i, "hours").format("YYYYMMDD/HH"));
      }

      dateList = _.uniq(dateList);

      let promises = [];
      _.forEach(dateList, (date) => {
        const cameraDataPath = this.cameraHash + "/" + date;
        let promise = storageWebCam
          .child(cameraDataPath)
          .listAll()
          .then((response) => {
            _.forEach(response.items, (item) => {
              // item.fullPath = {hash}/20200910/01/202009-10-011552,600.mp4 ---> 2020-09-10 01:15:52 として抽出
              let recordStartDatetime = item.fullPath
                .replace(/^.+\/([0-9¥-]+),([0-9]+).*$/gi, "$1")
                .replace(
                  /([0-9]{4})([0-9]{2})-?([0-9]{2})-([0-9]{2})([0-9]{2})([0-9]{2})/g,
                  "$1-$2-$3 $4:$5:$6",
                );
              // item.fullPath = {hash}/20200910/01/202009-10-011552,600.mp4 ---> 600(秒)を抽出
              let recordDurationSecond = item.fullPath.replace(
                /^.+\/([0-9¥-]+),([0-9]+).*$/gi,
                "$2",
              );
              recordDurationSecond = !isNaN(recordDurationSecond)
                ? Number(recordDurationSecond)
                : 0;

              let unixtime = moment.utc(recordStartDatetime).unix();

              if (unixtime >= this.start - 10 && unixtime <= this.end) {
                this.videoList.push({
                  id: unixtime,
                  start: unixtime,
                  duration: recordDurationSecond,
                  path:
                    process.env.VUE_APP_CLOUD_SOTRAGE_WEBCAM_URL +
                    item.fullPath,
                });
              }
            });
          })
          .catch((e) => {
            console.error(e);
          });
        promises.push(promise);
      });

      return Promise.all(promises);
    },

    getCurrentVideo(time) {
      for (let i in this.playVideoPathList) {
        let v = this.playVideoPathList[i];
        if (time >= v.start && time <= v.start + v.duration) {
          return v;
        }
      }
      return null;
    },

    getVideoIndex(id) {
      for (let i in this.videoList) {
        let v = this.videoList[i];
        if (id === v.id) {
          return i;
        }
      }
      return null;
    },

    // 1時間うち再生対象（10分）だけのリストを作成
    async cratePlayVideoPathList(id) {
      this.onPause();
      this.playVideoPathList = [];
      let indexStart = Number(this.getVideoIndex(id));
      let indexEnd = indexStart + 59;
      for (let step = indexStart; step < indexEnd; step++) {
        this.playVideoPathList.push(this.videoList[step]);
      }
      this.playStart = this.playVideoPathList[0].start;
      let last = this.playVideoPathList[this.playVideoPathList.length - 1];
      this.playEnd = last.start + last.duration;
      this.video_time = this.playStart;
      this.current = this.playVideoPathList[0].start;
      this.currentPlaylistId = this.playVideoPathList[0].id;
    },

    // 10分単位のプレイリストを作成
    cratePlayList() {
      let bass = 0;
      for (let step = 0; step < 6; step++) {
        if (this.videoList[bass] === "undefined") {
          break;
        }
        let start = moment.unix(this.videoList[bass].start).format("HH:mm:ss");
        let end = moment
          .unix(this.videoList[bass + 59].start)
          .format("HH:mm:ss");
        let item = {
          video: this.videoList[bass],
          cameraName: this.camera.name,
          duration: `${start} - ${end}`,
        };
        this.playList.push(item);
        bass = bass + 59;
      }
    },

    onloadeddata(ev) {
      let v = ev.target;
      v.currentTime = 0;
      this.load_count++;
      this.cameraMsg = `取得中... ${this.load_count} / ${
        this.playVideoPathList.length + 1
      }`;
      if (this.playVideoPathList.length === this.load_count) {
        this.load_count = 0;
        this.active_video = this.playVideoPathList[0].id;
        this.isLoadingCamera = false;
        this.initialized = true;
        this.cameraMsg = "";
      }
    },

    onClickPlaylist(id) {
      if (this.currentPlaylistId === id) return;
      this.currentPlaylistId = id;
      this.isLoadingCamera = true;
      this.initialized = false;
      this.cratePlayVideoPathList(id);
      this.active_video = this.playVideoPathList[0].id;
      this.current = this.playVideoPathList[0].id;
    },

    onPlay() {
      // 最後まで再生されていたら、初めから再生開始
      if (this.isEnded) {
        this.current = this.playVideoPathList[0].id;
        this.isEnded = false;
      }
      this.isPlay = !this.isPlay;
      if (this.isPlay) {
        this.createTicker();
      } else {
        createjs.Ticker.reset();
        createjs.Ticker.removeAllEventListeners("tick");
        let v = this.getCurrentVideo(this.current);
        let videoTag = this.$refs[v.start][0];
        if (videoTag) {
          videoTag.pause();
        }
      }
    },

    onPause() {
      this.isPlay = false;
      createjs.Ticker.reset();
      createjs.Ticker.removeAllEventListeners("tick");
      this.$refs.playBackControls.setPause();
    },

    onChangeVolume(volume) {
      this.volume = volume;
      let v = this.getCurrentVideo(this.current);
      let videoTag = this.$refs[v.start][0];
      if (videoTag) {
        videoTag.volume = volume;
      }
    },

    onChangeSeek(time) {
      this.isSeekEvent = true;
      this.current = time;
    },

    setFPS(fps) {
      this.fps = fps;
      createjs.Ticker.framerate = this.fps;
    },

    setFullscreen(isFullscreen) {
      this.$emit("onChangeFullscreen", isFullscreen);
      if (isFullscreen) {
        this.videoContainer.requestFullscreen();
      } else {
        document.exitFullscreen();
        this.$refs.playBackControls.setStyleToSmall();
      }
    },

    onFullscreenChange() {
      // Escボタンによるフルスクリーン解除をフック
      if (!document.fullscreenElement) {
        this.$refs.playBackControls.setStyleToSmall();
        this.$emit("onChangeFullscreen", false);
      }
    },

    onClickCloseButton() {
      this.playVideoPathList = [];
      this.playList = [];
      this.videoList = [];
      this.isLoadingCamera = true;
      createjs.Ticker.removeAllEventListeners("tick");
    },

    createTicker() {
      createjs.Ticker.removeAllEventListeners("tick");
      createjs.Ticker.framerate = this.fps;
      createjs.Ticker.timingMode = createjs.Ticker.RAF_SYNCHED;
      createjs.Ticker.addEventListener("tick", this.handleTick);
    },

    handleTick() {
      this.current++;
    },
  },
  mounted() {
    const next = this.$children[0].$refs.btnclose;
    if (next) {
      next.$el.addEventListener("click", this.onClickCloseButton, false);
    }
    this.videoContainer = document.getElementById("video-container");
  },
  beforeDestroy() {
    this.videoList = [];
    this.playVideoPathList = [];
    createjs.Ticker.removeAllEventListeners("tick");
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

#play-back-player {
  overflow: hidden;
}
.con-vs-popup .vs-popup {
  width: 800px;
}
.camera-play-list {
  height: 250px;
}
.play-list-item {
  cursor: pointer;
}
.vs-popup--content {
  overflow: hidden;
}

.no-video {
  background-color: #000000;
  height: 100%;
  width: 100%;
}

.video {
  width: 100%;
  height: 100%;
  border-radius: 4px;
}

.history-camera-no-video {
  position: relative;
}

.history-camera-no-video p {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  margin: 0;
  padding: 0;
  color: white;
  z-index: 5;
}

#play-back-player-container {
  display: grid;
  grid-template-rows: 300px 80px;
  grid-template-columns: 500px 1fr;
  grid-template-areas:
    "area-main-video area-playlist"
    "area-video-controls area-playlist";

  .scroll-area {
    position: relative;
    width: 250px;
    height: 300px;
    overflow: auto;
  }
}

#item-main-video {
  grid-area: area-main-video;
  background-color: #000000;
}

#item-video-controls {
  grid-area: area-video-controls;
}
#item-playlist {
  grid-area: area-playlist;
  padding: 1rem;
}

#playlist-container {
  display: grid;
  grid-template-columns: 220px;
  grid-template-areas:
    "area-playlist-header"
    "area-playlist-content";
}

.play-list-item-info {
  width: 150px;
  p.on-playing {
    font-weight: 200;
    color: #7367f0;
  }
}

.on-playing {
  border: #333333;
}
</style>
